import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { categoryGroups } from '@/mocks/categories';

export default function CategoryFilter() {
  const [activeId, setActiveId] = useState(categoryGroups[0].id);
  const active = categoryGroups.find((group) => group.id === activeId) ?? categoryGroups[0];

  return (
    <section id="categories" className="w-full bg-background-50 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <SectionHeading
        eyebrow="分类导航"
        title="按内容分类浏览"
        description="不同题材的整理方式不太一样：电影看上线时间，剧集动漫看集数进度，综艺与纪实按期次。选择一个分类，就能看到该分类的整理说明与代表条目。"
      />

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-5 lg:gap-6">
        <div className="lg:col-span-4">
          <div
            className="flex lg:flex-col gap-2 overflow-x-auto lg:overflow-visible pb-1 lg:pb-0"
            role="tablist"
            aria-label="内容分类"
          >
            {categoryGroups.map((group) => {
              const isActive = group.id === activeId;
              return (
                <button
                  key={group.id}
                  type="button"
                  role="tab"
                  aria-selected={isActive}
                  onClick={() => setActiveId(group.id)}
                  className={`flex items-center justify-between gap-3 px-4 py-3 rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer ${
                    isActive
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-800 hover:bg-primary-100 hover:text-primary-800'
                  }`}
                >
                  <span className="flex items-center gap-2">
                    <i className="ri-folder-3-line" aria-hidden="true"></i>
                    {group.label}
                  </span>
                  <span className={`text-xs ${isActive ? 'text-background-100' : 'text-foreground-500'}`}>
                    {group.items.length} 条
                  </span>
                </button>
              );
            })}
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="h-full rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-accent-100 text-accent-900 flex items-center justify-center">
                <i className="ri-price-tag-3-line text-lg" aria-hidden="true"></i>
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">
                {active.label}类内容整理
              </h3>
            </div>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">{active.intro}</p>

            <h4 className="mt-6 text-xs md:text-sm font-medium text-foreground-600">
              <a href="#hot" className="hover:text-primary-700 transition-colors">
                代表条目
              </a>
            </h4>
            <ul className="mt-3 flex flex-wrap gap-2">
              {active.items.map((title) => (
                <li
                  key={title}
                  className="text-xs md:text-sm px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-foreground-800"
                >
                  {title}
                </li>
              ))}
            </ul>

            <p className="mt-6 text-xs md:text-sm text-foreground-600 leading-relaxed">
              完整条目可在
              <a href="#hot" className="mx-1 text-primary-700 hover:text-primary-800 underline underline-offset-2">
                热门新片
              </a>
              区切换同名标签查看，分类内容会随整理结果持续补充。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}